import { Realty, services } from '@ambita/ambita-components-core';

const util = services.util;

function transformContacts(contactsData: Realty.ApiResponse) {
  if (contactsData.items && contactsData.items.length > 0) {
    const contacts: Realty.ApiPerson[] = contactsData.items;
    const retObject: any = {
      contacts: []
    };

    contacts.forEach((contact: Realty.ApiPerson) => {
      const tmpObj: any = util.pick(contact, [
        'name',
        'personalNumber'
      ]);

      tmpObj.role = 'contact';
      retObject.contacts.push(tmpObj);
    });

    return retObject;
  }
}

export default transformContacts;
